import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Badge,
  Input,
  UncontrolledTooltip,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import {
  DEFAULT_RECORDS_PER_PAGE,
  PAYMENT_STATUS_OPTION,
} from "components/constant";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import { ISOToHumanReadableDate } from "components/CommonComponents/CommonFunctions";
import { COURSES } from "components/constant";
import { BATCH_OPTIONS } from "components/constant";

//static data
const receiptData = [
  {
    id: 1,
    receiptNumber: "RCPT-2026-001",
    receiptDate: "01 Apr 2026, 10:30 AM",
    traineeName: "Amit Sharma",
    organizationName: "Tata Power",
    courseName: "Electrical Safety",
    batchName: "Batch A1",
    amountPaid: 49.99,
    transactionId: "TXN1001",
    status: "Paid",
    attachment: "receipt_001.pdf",
  },
  {
    id: 2,
    receiptNumber: "RCPT-2026-002",
    receiptDate: "02 Apr 2026, 02:15 PM",
    traineeName: "Neha Patil",
    organizationName: "Reliance Energy",
    courseName: "Power Systems Advanced",
    batchName: "Batch B1",
    amountPaid: 0,
    transactionId: "TXN1002",
    status: "Pending",
    attachment: null,
  },
  {
    id: 3,
    receiptNumber: "RCPT-2026-003",
    receiptDate: "03 Apr 2026, 09:45 AM",
    traineeName: "Rahul Verma",
    organizationName: "L&T Electrical",
    courseName: "Industrial Wiring Basics",
    batchName: "Batch C1",
    amountPaid: 39.99,
    balanceAmount: 0,
    transactionId: "TXN1003",
    status: "Paid",
    attachment: "receipt_003.pdf",
  },
  {
    id: 4,
    receiptNumber: "RCPT-2026-004",
    receiptDate: "04 Apr 2026, 11:20 AM",
    traineeName: "Priya Singh",
    organizationName: "Adani Power",
    courseName: "Substation Operations",
    batchName: "Batch D1",
    amountPaid: 30,
    transactionId: "TXN1004",
    status: "Partial",
    attachment: "receipt_004.pdf",
  },
  {
    id: 5,
    receiptNumber: "RCPT-2026-005",
    receiptDate: "05 Apr 2026, 04:50 PM",
    traineeName: "Karan Mehta",
    organizationName: "Siemens",
    courseName: "Transformer Maintenance",
    batchName: "Batch E1",
    amountPaid: 69.99,
    transactionId: "TXN1005",
    status: "Pending",
    attachment: null,
  },
  {
    id: 6,
    receiptNumber: "RCPT-2026-006",
    receiptDate: "06 Apr 2026, 08:10 AM",
    traineeName: "Sneha Kulkarni",
    organizationName: "ABB India",
    courseName: "Energy Management Basics",
    batchName: "Batch F1",
    amountPaid: 0,
    transactionId: "TXN1006",
    status: "Paid",
    attachment: "receipt_006.pdf",
  },
  {
    id: 7,
    receiptNumber: "RCPT-2026-007",
    receiptDate: "07 Apr 2026, 01:35 PM",
    traineeName: "Rohit Gupta",
    organizationName: "BHEL",
    courseName: "Panel Wiring Techniques",
    batchName: "Batch G1",
    amountPaid: 0,
    transactionId: "TXN1007",
    status: "Pending",
    attachment: null,
  },
  {
    id: 8,
    receiptNumber: "RCPT-2026-008",
    receiptDate: "08 Apr 2026, 05:05 PM",
    traineeName: "Anjali Deshmukh",
    organizationName: "Mahindra Power",
    courseName: "Advanced Electrical Safety",
    batchName: "Batch H1",
    amountPaid: 59.99,
    transactionId: "TXN1008",
    status: "Paid",
    attachment: "receipt_008.pdf",
  },
  {
    id: 9,
    receiptNumber: "RCPT-2026-009",
    receiptDate: "09 Apr 2026, 10:00 AM",
    traineeName: "Vikas Yadav",
    organizationName: "NTPC",
    courseName: "Grid Operations Fundamentals",
    batchName: "Batch I1",
    amountPaid: 0,
    transactionId: "TXN1009",
    status: "Paid",
    attachment: "receipt_009.pdf",
  },
  {
    id: 10,
    receiptNumber: "RCPT-2026-010",
    receiptDate: "10 Apr 2026, 03:20 PM",
    traineeName: "Pooja Nair",
    organizationName: "Crompton Greaves",
    courseName: "Electrical Safety",
    batchName: "Batch A2",
    amountPaid: 49.99,
    transactionId: "TXN1010",
    status: "Paid",
    attachment: "receipt_010.pdf",
  },
  {
    id: 11,
    receiptNumber: "RCPT-2026-011",
    receiptDate: "11 Apr 2026, 12:10 PM",
    traineeName: "Arjun Reddy",
    organizationName: "Hitachi Energy",
    courseName: "Power Systems Advanced",
    batchName: "Batch B2",
    amountPaid: 0,
    transactionId: "TXN1011",
    status: "Pending",
    attachment: null,
  },
  {
    id: 12,
    receiptNumber: "RCPT-2026-012",
    receiptDate: "12 Apr 2026, 09:30 AM",
    traineeName: "Meera Joshi",
    organizationName: "Schneider Electric",
    courseName: "Industrial Wiring Basics",
    batchName: "Batch C2",
    amountPaid: 39.99,
    transactionId: "TXN1012",
    status: "Paid",
    attachment: "receipt_012.pdf",
  },
  {
    id: 13,
    receiptNumber: "RCPT-2026-013",
    receiptDate: "13 Apr 2026, 02:45 PM",
    traineeName: "Suresh Iyer",
    organizationName: "GE Power",
    courseName: "Substation Operations",
    batchName: "Batch D2",
    amountPaid: 0,
    transactionId: "TXN1013",
    status: "Pending",
    attachment: null,
  },
  {
    id: 14,
    receiptNumber: "RCPT-2026-014",
    receiptDate: "14 Apr 2026, 11:55 AM",
    traineeName: "Deepika Rao",
    organizationName: "Voltas",
    courseName: "Transformer Maintenance",
    batchName: "Batch E2",
    amountPaid: 69.99,
    transactionId: "TXN1014",
    status: "Paid",
    attachment: "receipt_014.pdf",
  },
  {
    id: 15,
    receiptNumber: "RCPT-2026-015",
    receiptDate: "15 Apr 2026, 04:00 PM",
    traineeName: "Manoj Kumar",
    organizationName: "Ashok Leyland",
    courseName: "Energy Management Basics",
    batchName: "Batch F2",
    amountPaid: 0,
    transactionId: "TXN1015",
    status: "Paid",
    attachment: "receipt_015.pdf",
  },
];
const getStatusColor = (status) => {
  switch (status) {
    case "Paid":
      return "success";
    case "Pending":
      return "danger";
    case "Partial":
      return "secondary";
    default:
      return "light";
  }
};

function ReceiptListing() {
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);

  const columns = [
    { Header: "Sr. No.", accessor: "id" },
    { Header: "Receipt No", accessor: "receiptNumber" },
    {
      Header: "Receipt Date",
      accessor: "receiptDate",
      Cell: ({ value }) => ISOToHumanReadableDate(value),
    },
    {
      Header: "Trainee Details",
      accessor: "traineeName",
      Cell: ({ row }) => {
        const { traineeName, organizationName } = row.original;

        return (
          <div>
            <div>{traineeName || "-"}</div>
            <div>{organizationName || "-"}</div>
          </div>
        );
      },
    },
    {
      Header: "Course Details",
      accessor: "courseName",
      Cell: ({ row }) => {
        const { courseName, batchName } = row.original;

        return (
          <div>
            <div>{courseName || "-"}</div>
            <div>{batchName || "-"}</div>
          </div>
        );
      },
    },
    {
      Header: "Amount Paid",
      accessor: "amountPaid",
      Cell: ({ value }) => `₹ ${value}`,
    },
    { Header: "Transaction ID", accessor: "transactionId" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge color={getStatusColor(value)} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const data = row.original;

        return (
          <div className="d-flex gap-2">
            {/* VIEW */}
            <Button
              className="btn-link p-0"
              id={`view${data.id}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                handleViewReceipt(data);
              }}
            >
              <i className="fa fa-eye" />
            </Button>
            <UncontrolledTooltip target={`view${data.id}`}>
              View
            </UncontrolledTooltip>

            {/* DOWNLOAD */}
            <Button
              className="btn-link p-0 ml-2"
              id={`download${data.id}`}
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                // handleDownloadReceipt(data);
              }}
            >
              <i className="fa fa-download" />
            </Button>
            <UncontrolledTooltip target={`download${data.id}`}>
              Download
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  const [searchState, setSearchState] = useState({
    traineeName: "",
    ReceiptNo: "",
    courseName: null,
    batchName: null,
    paymentMode: null,
    date: "",
    filterParams: [],
  });

  const clearSearch = () => {
    setSearchState({
      traineeName: "",
      ReceiptNo: "",
      courseName: null,
      batchName: null,
      paymentMode: null,
      date: "",
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  const handleDownloadReceipt = (data) => {
    if (!data.attachment) {
      return;
    }
    // example download
    const link = document.createElement("a");
    link.href = `/uploads/${data.attachment}`;
    link.download = data.attachment;
    link.click();
  };

  const handleViewReceipt = (file) => {
    window.open("/Sample Pdf.pdf", "_blank");
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={
            props.data.value === "PAID"
              ? "success"
              : props.data.value === "PENDING"
                ? "danger"
                : "secondary"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={
            props.data.value === "PAID"
              ? "success"
              : props.data.value === "FAILED"
                ? "danger"
                : "warning"
          }
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };
  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex justify-content-between">
                <CardTitle tag="h3" className="mb-0">
                  Receipts
                </CardTitle>

                <div>
                  <Button className="btn-deep-blue">
                    <i className="fa-solid fa-upload mr-1 fa-lg" />
                    Export Receipts
                  </Button>
                </div>
              </CardHeader>

              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by receipt no."
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.receiptNumber}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          receiptNumber: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Input
                      type="text"
                      placeholder="Search by trainee name"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.traineeName}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          traineeName: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={COURSES}
                      placeholder="Course Name"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      value={searchState.courseName}
                      onChange={(selected) =>
                        setSearchState((prev) => ({
                          ...prev,
                          courseName: selected,
                        }))
                      }
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={BATCH_OPTIONS}
                      placeholder="Batch Name"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      value={searchState.batchName}
                      onChange={(selected) =>
                        setSearchState((prev) => ({
                          ...prev,
                          batchName: selected,
                        }))
                      }
                    />

                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={PAYMENT_STATUS_OPTION}
                      placeholder="Payment Status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      onKeyDown={handleKeyDown}
                    />

                    <div className="d-flex mr-2 mb-2 align-items-center date-range-wrapper">
                      <span className="mr-2">From</span>
                      <Input type="date" className="mr-1 mb-1 filter-select" />
                      <span className="mx-1">To</span>
                      <Input type="date" className="ml-1 mb-1 filter-select" />
                    </div>

                    <Button
                      color="default"
                      className="d-flex align-items-center mb-2 mt-0 filter-btn btn-deep-blue"
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>
                    {searchState.filterParams.length > 0 && (
                      <Button
                        color="default"
                        className="mb-3 filter-btn btn-simple"
                        onClick={clearSearch}
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className="mt-2 mb-3 mx-1">
                  {receiptData.length ? (
                    <span className="total-records">
                      Total Records : {receiptData.length}
                    </span>
                  ) : null}
                </div>

                <CommonTable
                  columns={columns}
                  data={receiptData.slice(
                    (pageNum - 1) * (DEFAULT_RECORDS_PER_PAGE || 10),
                    pageNum * (DEFAULT_RECORDS_PER_PAGE || 10),
                  )}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE || 10}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalPages={Math.ceil(
                    receiptData.length / DEFAULT_RECORDS_PER_PAGE,
                  )}
                  showPaginationBottom={true}
                  //   rowClick={(row) => hanldeOnRowClick(row)}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ReceiptListing;
